import { Controller, FieldValues } from 'react-hook-form'

import { FilterableListBox } from 'components/FilterableListBox'
import { ChipsInput } from './components/ChipsInput'
import { ChipsListFilterableProps } from './types'

export const ChipsListFilterable = <T extends FieldValues>({
  control,
  disabled,
  label,
  name,
  placeholder,
}: ChipsListFilterableProps<T>): React.JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({ field: { name, onChange, value }, fieldState: { error } }) => (
      <FilterableListBox
        error={error}
        label={label}
        placeholder={placeholder}
      >
        <ChipsInput<T> {...{ disabled, name, onChange, value }} />
      </FilterableListBox>
    )}
  />
)
